// V3 retains the V2 console navigation; data and relay remain on the V1 engine.
// assets
import {
  IconDashboard,
  IconArticle,
  IconCoin,
  IconAdjustments,
  IconKey,
  IconUser,
  IconUserScan,
  IconLayoutGrid,
  IconServer,
  IconWallet,
  IconReportMoney,
  IconUsersGroup,
  IconMessageCircle,
  IconChartBar
} from '@tabler/icons-react';

const icons = {
  IconDashboard,
  IconArticle,
  IconCoin,
  IconAdjustments,
  IconKey,
  IconUser,
  IconUserScan,
  IconLayoutGrid,
  IconServer,
  IconWallet,
  IconReportMoney,
  IconUsersGroup,
  IconMessageCircle,
  IconChartBar
};

// V2 控制台信息架构：用户项 + 管理项（价格与成本 / 供给与接入 / 用户消费…）
const panel = {
  id: 'panel',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: '概览',
      type: 'item',
      url: '/panel/dashboard',
      icon: icons.IconDashboard,
      breadcrumbs: false,
      isAdmin: false
    },
    {
      id: 'modelsquare',
      hideForAdmin: true,
      title: '模型广场',
      type: 'item',
      url: '/panel/modelsquare',
      icon: icons.IconLayoutGrid,
      breadcrumbs: false,
      isAdmin: false
    },
    {
      id: 'playground',
      hideForAdmin: true,
      title: '模型体验',
      type: 'item',
      url: '/panel/playground',
      icon: icons.IconMessageCircle,
      breadcrumbs: false,
      isAdmin: false
    },
    {
      id: 'token',
      hideForAdmin: true,
      title: 'API Key',
      type: 'item',
      url: '/panel/token',
      icon: icons.IconKey,
      breadcrumbs: false
    },
    {
      id: 'billing',
      hideForAdmin: true,
      title: '账单与用量',
      type: 'item',
      url: '/panel/billing',
      icon: icons.IconWallet,
      breadcrumbs: false,
      isAdmin: false
    },
    {
      id: 'team',
      title: '我的团队',
      type: 'item',
      url: '/panel/team',
      icon: icons.IconUsersGroup,
      breadcrumbs: false,
      isAdmin: false,
      hideForAdmin: true
    },
    {
      id: 'profile',
      hideForAdmin: true,
      title: '我的',
      type: 'item',
      url: '/panel/profile',
      icon: icons.IconUserScan,
      breadcrumbs: false,
      isAdmin: false
    },
    {
      id: 'product-pricing',
      title: '价格与成本',
      type: 'item',
      url: '/panel/product-pricing',
      icon: icons.IconCoin,
      breadcrumbs: false,
      isAdmin: true
    },
    {
      id: 'supply',
      title: '供给与路由',
      type: 'item',
      url: '/panel/supply',
      icon: icons.IconServer,
      breadcrumbs: false,
      isAdmin: true
    },
    {
      id: 'customer',
      title: '客户',
      type: 'item',
      url: '/panel/customer',
      icon: icons.IconUsersGroup,
      breadcrumbs: false,
      isAdmin: true
    },
    {
      id: 'customer-pricing',
      title: '客户定价',
      type: 'item',
      url: '/panel/customer-pricing',
      icon: icons.IconCoin,
      breadcrumbs: false,
      isAdmin: true
    },
    {
      id: 'user-spend',
      title: '用户消费',
      type: 'item',
      url: '/panel/user-spend',
      icon: icons.IconChartBar,
      breadcrumbs: false,
      isAdmin: true
    },

    {
      id: 'log',
      title: '用量与纪录',
      type: 'item',
      url: '/panel/log',
      icon: icons.IconArticle,
      breadcrumbs: false,
      isAdmin: true
    },
    {
      id: 'upstream-recon',
      title: '上游对账',
      type: 'item',
      url: '/panel/upstream-recon',
      icon: icons.IconReportMoney,
      breadcrumbs: false,
      isAdmin: true
    },
    {
      id: 'video-reconciliation',
      title: '视频对账',
      type: 'item',
      url: '/panel/video-reconciliation',
      icon: icons.IconReportMoney,
      breadcrumbs: false,
      isAdmin: true
    },
    {
      id: 'offlinetopup',
      title: '线下充值',
      type: 'item',
      url: '/panel/offlinetopup',
      icon: icons.IconReportMoney,
      breadcrumbs: false,
      isAdmin: true
    },
    {
      id: 'setting',
      title: '设定',
      type: 'item',
      url: '/panel/setting',
      icon: icons.IconAdjustments,
      breadcrumbs: false,
      isAdmin: true
    }
  ]
};

export default panel;
